import { Languages, useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';
import { useStoreUIV2 } from '../../hooks/useStore.hook';
import { Col } from '../col/col.component';
import { Icon } from '../icon/icon.component';
import { Popover } from '../popover';
import { Row } from '../row/row.component';
import { Text } from '../text/text.component';
import './myLangLocal.component.scss';
import classNames from 'classnames';

const flagMapper = {
  fr_FR: 'watermelon-fr_FR-untranslated',
  en_EN: 'watermelon-en_EN-untranslated',
  de_DE: 'watermelon-de_DE-untranslated',
  it_IT: 'watermelon-it_IT-untranslated',
} as const satisfies Record<Languages, string>;

export const MyLangLocal = observer(() => {
  const { SSOStore, I18NStore, GQLStore, NotificationStore } = useStoreUIV2();

  const { lang, t } = useTranslation();
  const [langSelected, setLangSelected] = useState<Languages | null>(null);
  const popoverRef = useRef<{ setOpen: (value: boolean) => void }>(null);
  return (
    <div className="myLangLocal">
      <Popover
        ref={popoverRef}
        withPadding={false}
        triggerElement={
          <Row
            className="myLangLocal__trigger"
            gap={8}
            alignItems="center"
            justifyContent="center"
          >
            <Text variant="subhead" color="deep_indigo">
              {t(flagMapper[langSelected || lang!])}
            </Text>
            <Icon variant="globe" color="deep_indigo" />
          </Row>
        }
      >
        <div className="myLangLocal__content">
          {Object.entries(flagMapper).map(([key, value]) => (
            <div
              onClick={() => {
                I18NStore.setLang(key as Languages);
                popoverRef.current?.setOpen(false);
              }}
              className={classNames('myLangLocal__content__item', {
                'myLangLocal__content__item--selected': lang === key,
              })}
            >
              <Text variant="body" color="black_70">
                {t(value)}
              </Text>
            </div>
          ))}
        </div>
      </Popover>
    </div>
  );
});
